import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue'
  import useCourse from '@/composables/useCourse'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useSegment from '@/composables/useSegment'
  import useCommonMixin from '@/composables/useCommonMixin'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadMaterials',
  setup(__props) {

  const { course } = useCourse()
  const { bigDownloadIcon, iconPdf } = useIcons()
  const { courseMaterialDownloaded, trackPage, pageViewed } = useSegment()
  const { downloadItem, isPdfFile, isImageFile } = useCommonMixin()

  const downloadables = computed(() => course.value?.downloadables)
  const downloadContent = (downloadUrl: string) => {
    courseMaterialDownloaded(course.value!.id, course.value!.title, downloadUrl)
    downloadItem(downloadUrl)
  }

  const itemImage = (url: string) => {
    if (url && isPdfFile(url)) return iconPdf.value
    if (url && isImageFile(url)) return bigDownloadIcon.value
    return bigDownloadIcon.value
  }

  onMounted(() => {
    trackPage('Download Materials')
    pageViewed('Download Materials')
  })

return { __sfc: true,course, bigDownloadIcon, iconPdf, courseMaterialDownloaded, trackPage, pageViewed, downloadItem, isPdfFile, isImageFile, downloadables, downloadContent, itemImage, computed, onMounted, useCourse, KetchUpButton, useIcons, SVGRenderer, useSegment, useCommonMixin, HTMLRenderer }
}

})